import { Action } from 'redux';
import { WholeHealthBalanceCrosswalk } from '../interfaces/whole-health-balance-and-agent-cube-state-structure.interface';
import { WhbCrosswalk } from '../../interfaces/member-lookup.interface';

export const WHOLE_HEALTH_BALANCE_CROSSWALK_STATE_NAME = 'WholeHealthBalanceCrosswalk';

const INITIAL_STATE: WholeHealthBalanceCrosswalk = {
  whbcrosswalk: {
    whbcrosswalk: false,
    oldGroup: '',
    newGroup: '',
    umi: ''
  }
};

const SAVE_CROSSWALK_INFO = 'SAVE_CROSSWALK_INFO';

export class UserInfoAppAction implements Action {
  type: string;
  whbcrosswalk?: WhbCrosswalk;
}

export function saveCrossWalkInfo(crossWalk: WhbCrosswalk) {
  return {
    type: SAVE_CROSSWALK_INFO,
    whbcrosswalk : crossWalk
  };
}

/**
 * Login info reducers
 */
export function WholeHealthBalanceCrosswalk(
  state: WholeHealthBalanceCrosswalk = INITIAL_STATE,
  action: UserInfoAppAction
) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case SAVE_CROSSWALK_INFO:
      copiedState.whbcrosswalk = action.whbcrosswalk;
      return Object.assign({}, state, copiedState);

    default:
      return state;

  }
}
